import Home from '../views/Home.vue'
import Layout from '@/pages/layout/Layout.vue'
import Explorer from '@/pages/explorer/Explorer.vue'
import Dashboard from '@/pages/dashboard/Dashboard.vue'
import ChartDetailsViewer from '@/pages/ChartDetailsViewer/ChartDetailsViewer.vue'
import CustomMetricsPage from '@/pages/CustomMetrics/CustomMetricsPage.vue'
import CustomMetricsListPage from '@/pages/CustomMetrics/CustomMetricsListPage.vue'
import CONSTANTS from '@/constants/Config.constants'
import labels from '@/translations/labels.json'
import ProjectOverview from '@/pages/project/ProjectOverview.vue'
import ProjectList from '@/pages/ProjectList/ProjectList.vue'
import LandingPageVue from '@/views/LandingPage.vue'
import HelpPage from '@/pages/help/HelpPage.vue'
import OidcCallbackView from '@/views/OidcCallbackView.vue'
//import { Route } from '@/models/RouteInterface'
import { RouteRecordRaw } from 'vue-router'
import ProjectConfiguration from '@/pages/project/ProjectConfiguration.vue'
import SnapshotManagment from '@/pages/snapshot/SnapshotManagment.vue'
import GlobalFilters from '@/pages/filters/GlobalFilters.vue'

export const globalRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'HomePage',
    component: Home,
    meta: { requiresAuth: true },
    redirect: undefined,
  },
  {
    path: '/home',
    name: 'LandingPage',
    component: LandingPageVue,
    meta: { requiresAuth: false },
    redirect: undefined,
  },
  {
    path: '/callback',
    name: 'oidcCallback',
    component: OidcCallbackView,
    redirect: undefined,
  },

  {
    path: CONSTANTS.BASE_ROUTES.CALLBACK,
    name: CONSTANTS.ROUTES_NAME.CALLBACK,
    component: LandingPageVue,
  },
  {
    path: '/app',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: CONSTANTS.BASE_ROUTES.DASHBOARD,
        name: labels.SIDEBAR.MAIN.DASHBOARD,
        component: Dashboard,
        meta: {
          title: 'Dashboard',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.EXPLORER_BASE,
        name: labels.SIDEBAR.MAIN.EXPLORER,
        component: Explorer,
        meta: {
          title: 'Explorer',
          auth: true,
        },
        children: [
          {
            name: labels.SIDEBAR.MAIN.EXPLORER_GRAPH,
            path: CONSTANTS.BASE_ROUTES.EXPLORER_GRAPH,
            component: Explorer,
          },
        ],
      },
      {
        path: CONSTANTS.BASE_ROUTES.PROJECTOVERVIEW,
        name: labels.SIDEBAR.MAIN.PROJECT_OVERVIEW,
        component: ProjectOverview,
        meta: {
          title: 'Project Overview',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.PROJECTCONFIGURATION,
        name: labels.SIDEBAR.MAIN.PROJECT_CONFIGURATION,
        component: ProjectConfiguration,
        meta: {
          title: 'Project Configuration',
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.SNAPSHOT_MANAGMENT,
        name: labels.SIDEBAR.MAIN.SNAPSHOTS_MANAGMENT,
        component: SnapshotManagment,
        meta: {
          title: 'Snapshots Managment',
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.GLOBAL_FILTERS,
        name: labels.SIDEBAR.MAIN.GLOBAL_FILTERS,
        component: GlobalFilters,
        meta: {
          title: 'Global Filters',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.PROJECTLIST,
        name: labels.SIDEBAR.MAIN.PROJECT_LIST,
        component: ProjectList,
        meta: {
          title: 'Project List',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.DASHBOARD_DETAILS_VIEWER,
        name: labels.DASHBOARD_DETAILS_VIEWER.TITLE,
        component: ChartDetailsViewer,
        meta: {
          title: 'Dashboard Details Viewer',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.HELP,
        name: labels.HELP.TITLE,
        component: HelpPage,
        meta: {
          title: 'Help',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.CUSTOM_METRICS,
        name: labels.CUSTOM_METRIC.CUSTOM_METRICS,
        component: CustomMetricsListPage,
        meta: {
          title: 'Custom Metrics',
          auth: true,
        },
      },
      {
        path: CONSTANTS.BASE_ROUTES.CUSTOM_METRIC,
        name: labels.CUSTOM_METRIC.CUSTOM_METRIC,
        component: CustomMetricsPage,
        meta: {
          title: 'Custom Metric',
          auth: true,
        },
      },
    ],
  },
]
